exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2j5uvTujJHjY5LdASsq1Gq{width:510px}html[dir] ._2j5uvTujJHjY5LdASsq1Gq{border-radius:4px;border:none}html[dir] ._2j5uvTujJHjY5LdASsq1Gq .ms-Callout-beakCurtain,html[dir] ._2j5uvTujJHjY5LdASsq1Gq .ms-Callout-main{border-radius:4px}._2j5uvTujJHjY5LdASsq1Gq.mgqqTJ6uksFNdiAFQe2Om{width:380px}@media screen and (-ms-high-contrast:active){html[dir] ._2j5uvTujJHjY5LdASsq1Gq{border-width:1px;border-style:solid;border-color:windowText}}", ""]);
// Exports
exports.locals = {
	"callout": "_2j5uvTujJHjY5LdASsq1Gq",
	"isInEditMode": "mgqqTJ6uksFNdiAFQe2Om"
};